import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import { Observable, Subscription } from 'rxjs';
import { KundeKortService, CUSTOMER_CATEGORIES } from '../../../services/kunde-kort.service';

interface BoardColumn {
  category: string;
  customers: any[];
}

@Component({
  selector: 'app-kunde-kort-board',
  templateUrl: './kunde-kort-board.component.html',
  styleUrls: ['./kunde-kort-board.component.css']
})
export class KundeKortBoardComponent implements OnInit, OnDestroy {
  @Input() customers$: Observable<any>;
  @Output() openDetail = new EventEmitter<any>();

  categories = CUSTOMER_CATEGORIES;
  columns: BoardColumn[] = [];
  connectedDropListIds: string[] = [];
  private sub: Subscription;

  constructor(private kundeKortService: KundeKortService) {}

  ngOnInit() {
    this.connectedDropListIds = this.categories.map(c => this.dropListId(c));
    this.sub = this.customers$.subscribe((customers: any[]) => {
      this.columns = this.categories.map(category => ({
        category,
        customers: (customers || [])
          .filter(c => (c.category || this.categories[0]) === category)
          .sort((a, b) => (a.name || '').localeCompare(b.name || ''))
      }));
    });
  }

  dropListId(category: string): string {
    return 'kkb-column-' + category;
  }

  drop(event: CdkDragDrop<any[]>, targetCategory: string) {
    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
      return;
    }
    const customer = event.previousContainer.data[event.previousIndex];
    transferArrayItem(event.previousContainer.data, event.container.data, event.previousIndex, event.currentIndex);
    if (customer?.kundekortId) {
      this.kundeKortService.updateCustomer(customer.kundekortId, { category: targetCategory })
        .catch(err => console.error('Error updating customer category', err));
    }
  }

  cardClick(customer: any) {
    this.openDetail.emit(customer);
  }

  ngOnDestroy() {
    if (this.sub) this.sub.unsubscribe();
  }
}
